import React, { useState, useEffect } from "react";
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../Univ.js'

function DonationList() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [DonateData, setDonateData] = useState([]);

  useEffect(() => {
        fetchData();
  }, []);
  function fetchData() {
    axios.get(`${baseUrl}donate-update/`)
      .then(response => {
        setDonateData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  const columns = [
{
  field: 'donor',
  headerName: 'Donor Name',
  width: 140,
  renderCell: (params) => params.row?.donor?.donor || '',
},


    { field: 'blood', headerName: 'Blood Group', width: 120 },
    { field: 'unit', headerName: 'Unit (ml)', width: 120 },
    { field: 'donate_on', headerName: 'Donated On', width: 120 },
    { field: 'addedby', headerName: 'Added By', width: 120 },
  ];
  return (
        <section className="container mt-4">
            <div style={{ height: "100%", width: "100%" }} className="mt-5">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-hand-holding-droplet"
            aria-hidden="true" style={{color: 'red'}}></i> Donation List</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={DonateData}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>
        </section>
  );
}

export default DonationList;
